// TODO: Check image size on upload and then error if dimensions are too small: https://stackoverflow.com/a/8904008
// FIXME: If a new logo is updated to replace a past logo, the brand isn't updated in the back-end

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Col, Row } from 'react-grid-system';

import _ from 'lodash';

import { useBrand } from '../../_libs/hooks/useBrand';

import Navigation from '../../molecules/Navigation';
import ErrorBoundary from '../../organisms/ErrorBoundary';
import LogoUploaderAndColorPicker from '../../organisms/LogoUploaderAndColorPicker';

const IntroBrand = (): JSX.Element => {
  const {
    isValidBrand,
    primaryBrand,
  } = useBrand();
  const navigate = useNavigate();

  useEffect(() => {
    // If primaryBrand does not exist, go back to set it
    if (!isValidBrand(primaryBrand)) {
      navigate('/intro/');
    } else {
      document.body.style.backgroundColor = null;
      document.body.style.color = null;
      document.getElementById('body-gradient').style.opacity = '0';
      document.getElementById('js-bg').style.opacity = '1';
    }
  }, []);

  return (
    <ErrorBoundary>
      <Navigation />
      <Container>
        <Row align="center" style={{
          minHeight: 'calc(100vh - 105px)',
          paddingBottom: '52.5px',
        }}>
          <Col sm={8}>
            <LogoUploaderAndColorPicker
              confirmationCallback={() => {
                navigate('/materials/');
              }}
            />
            {/* <Link to="/zip/">Skip</Link> */}
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
};

export default IntroBrand;
